module.exports = __webpack_public_path__ + "static/media/LT1-BG2.424523be.jpg";